import { render, staticRenderFns } from "./DesignForm.vue?vue&type=template&id=f76b99c8&scoped=true"
import script from "./DesignForm.vue?vue&type=script&lang=js"
export * from "./DesignForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76b99c8",
  null
  
)

export default component.exports